import ApiService from '../api.service'

export interface NotaAdesiva {
    id: number
    empresaId: number
    funcionarioId: number
    /** ISO do dia (`YYYY-MM-DDT00:00:00.000Z`). */
    data: string
    /** `null` prende a nota ao dia inteiro. */
    registroId: number | null
    texto: string
    visivelFuncionario: boolean
    autorId: number
    autor: { categoria: number; nome: string }
    createdAt: string
    updatedAt: string
    canEditarTexto: boolean
    canExcluir: boolean
    canAlternarVisibilidade: boolean
}

/** Com `registroId` a API copia funcionário e dia do registro. */
export type NovaNotaAdesiva = {
    texto: string
    /** Só gestor escolhe; para funcionário a API força `true`. */
    visivelFuncionario?: boolean
} & (
    | { registroId: number }
    | {
          funcionarioId: number
          /** `YYYY-MM-DD`. */
          data: string
      }
)

/** Notas de um registro, da visão mensal (funcionário × período) ou diária (empresa × dia); datas em `YYYY-MM-DD`. */
export type NotasAdesivasQuery =
    | { registroId: number }
    | { funcionarioId: number; dataInicial: string; dataFinal: string }
    | { empresaId: number; dia: string }

export const notasAdesivas = new ApiService<
    NovaNotaAdesiva,
    NotaAdesiva,
    NotasAdesivasQuery
>('notas-adesivas')
